/* eslint-disable sort-keys-fix/sort-keys-fix */

export const SPACING = {
  spacing5: '0.313rem',
  spacing10: '0.625rem',
  spacing15: '0.938rem',
  spacing20: '1.25rem',
  spacing30: '1.875rem',
  spacing50: '3.125rem',
  spacing75: '4.688rem',
  spacing100: '6.25rem',
  spacing200: '12.5rem',
  spacing300: '18.75rem'
}
